import type { ComponentProps } from 'react';

import type { TabList } from '@change/ds-core-ui/Tabs';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useNewsAndGuidesListPageData } from '#src/app/pages/newsAndGuides/list/pageContext';

type Result = ModelHookResult<{
	guides: boolean;
	tabItems: ComponentProps<typeof TabList>['items'];
}>;

export function usePageHeading(): Result {
	const { translate } = useI18n();
	const {
		data: { hasGuides, countryCode, guides },
	} = useNewsAndGuidesListPageData();

	const urlBase = `/l/${encodeURIComponent(countryCode)}`;

	const tabItems = [
		{
			id: 'news',
			label: translate('fe.components.news_header.news'),
			href: urlBase,
		},
		...(hasGuides
			? [
					{
						id: 'guides',
						label: translate('fe.components.footer.guides'),
						href: `${urlBase}?category=guides`,
					},
				]
			: []),
	];

	return {
		data: {
			guides,
			tabItems,
		},
	};
}
